import { render, staticRenderFns } from "./MedicalTeamAdd.vue?vue&type=template&id=34bf605f"
import script from "./MedicalTeamAdd.vue?vue&type=script&lang=js"
export * from "./MedicalTeamAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports